var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 14C8.85652 14 10.637 13.2625 11.9497 11.9497C13.2625 10.637 14 8.85652 14 7C14 5.14348 13.2625 3.36301 11.9497 2.05025C10.637 0.737498 8.85652 0 7 0C5.14348 0 3.36301 0.737498 2.05025 2.05025C0.737498 3.36301 0 5.14348 0 7C0 8.85652 0.737498 10.637 2.05025 11.9497C3.36301 13.2625 5.14348 14 7 14ZM7.75 3.5C7.75 3.30109 7.67098 3.11032 7.53033 2.96967C7.38968 2.82902 7.19891 2.75 7 2.75C6.80109 2.75 6.61032 2.82902 6.46967 2.96967C6.32902 3.11032 6.25 3.30109 6.25 3.5V7C6.25 7.11643 6.27711 7.23127 6.32918 7.33541C6.38125 7.43955 6.45685 7.53014 6.55 7.6L8.55 9.1C8.62879 9.15909 8.71845 9.20209 8.81386 9.22653C8.90928 9.25098 9.00856 9.25639 9.10607 9.24246C9.20357 9.22853 9.29737 9.19554 9.38212 9.14536C9.46687 9.09518 9.54091 9.02879 9.6 8.95C9.65909 8.87121 9.70209 8.78155 9.72653 8.68614C9.75098 8.59072 9.75639 8.49144 9.74246 8.39393C9.72853 8.29643 9.69554 8.20263 9.64536 8.11788C9.59518 8.03313 9.52879 7.95909 9.45 7.9L7.75 6.625V3.5Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.6bf8f6011b5cc07653981f199962522f.svg";
export { ForwardRef as ReactComponent };